<template>
    <div style="max-width: 100%">
        <div style="text-align: center; padding-top: 10px; font-weight: normal" class="dynamic-component-tab-button btnTab" 
            v-bind:class="{ 'dynamic-component-tab-button-active': showThisTabItem,
              'my-list-specific-style': tabName === 'My List' && showThisTabItem
            }" v-on:click="tabItemClicked">
           <span >{{tabName}}</span>
        </div>
        <v-divider></v-divider>
   </div>
</template>
<script>
  import { mapState} from "vuex";
  export default {
      props:["tabName", "showThisTabItem"],
      methods:{
        tabItemClicked() {
          this.$emit("tabItemClicked", this.tabName);
        },
      },
      computed: {
        ...mapState(["userInfo"]),
      }
    }
</script>
<style scoped>
.btnTab{
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  vertical-align: middle;
}
.btnTab{
  font-size: 0.875em;
  padding-bottom: 10px !important;
}
.btnTab:focus {outline:0;}
 .dynamic-component-tab-button {
  height: 39px;
  width: 154px;
  color: #C9C9C9
}
.dynamic-component-tab-button-active {
  background: none;
  color: #3FE090;
  border-bottom: 3px solid #3FE090;
  font-weight: bold !important;
}
.btnLeftTab:nth-of-type(2)
  .dynamic-component-tab-button.dynamic-component-tab-button-active {
  background: none;
  color: #febd1f;
  border-bottom: 3px solid #febd1f;
  font-weight: bold !important;
}
.my-list-specific-style {
  background: none;
  color: #C7C7C7 !important;
  border-bottom: 3px solid #C7C7C7 !important;
  font-weight: bold !important;
}
@media (pointer: fine){
  .btnTab{
  padding: 20px 0 !important;
  height: 55px;
}
}
</style>
